import React, { PureComponent } from "react";
import "./WordCloud.scss";

interface Props {
  chart: Array<string>;
}

class WordCloud extends PureComponent<Props> {
  render() {
    const { chart } = this.props;

    return (
      <div className="WordCloud">
        {chart.sort().map((d, i) => (
          <span key={i} className="speech-bubble">
            {d}
          </span>
        ))}
      </div>
    );
  }
}

export default WordCloud;
